export const service = {
  error: {
    patientSerialError: {
      ko: '사용자에게 장치가 여러 개 연결되어 차트를 표시할 수 없습니다.',
      en: 'The chart cannot be displayed because multiple devices are connected to the user.',
      fr: '',
    },
  },
};
